import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, message, Card } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined, SettingOutlined } from "@ant-design/icons";
import axiosInstance from "../../configs";
import PermissionMatrix from "./PermissionMatrix";
import { MENU_CONFIG } from "../../utils/menuConfig";

const RoleAccess = () => {
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [matrixVisible, setMatrixVisible] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null); // For edit/matrix
    const [form] = Form.useForm();

    useEffect(() => {
        syncMenus();
        fetchRoles();
    }, []);

    const syncMenus = async () => {
        try {
            await axiosInstance.post("/roles/sync-menus", { menus: MENU_CONFIG });
            // console.log("Menus synced");
        } catch (err) {
            console.error("Failed to sync menus", err);
        }
    };

    const fetchRoles = async () => {
        setLoading(true);
        try {
            const res = await axiosInstance.get("/roles");
            setRoles(res.data);
        } catch (err) {
            console.error(err);
            message.error("Gagal memuat roles");
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = () => {
        setSelectedRole(null);
        form.resetFields();
        setModalVisible(true);
    };

    const handleEdit = (record) => {
        setSelectedRole(record);
        form.setFieldsValue(record);
        setModalVisible(true);
    };

    const handleDelete = (record) => {
        Modal.confirm({
            title: "Hapus Role",
            content: `Apakah Anda yakin ingin menghapus role "${record.user_level}"?`,
            onOk: async () => {
                try {
                    await axiosInstance.delete(`/roles/${record.id_user_level}`);
                    message.success("Role berhasil dihapus");
                    fetchRoles();
                } catch (err) {
                    message.error(err.response?.data?.error || "Gagal menghapus role");
                }
            }
        });
    };

    const handlePermissions = (record) => {
        setSelectedRole(record);
        setMatrixVisible(true);
    };

    const handleSave = async () => {
        try {
            const values = await form.validateFields();
            if (selectedRole) {
                await axiosInstance.put(`/roles/${selectedRole.id_user_level}`, values);
                message.success("Role berhasil diupdate");
            } else {
                await axiosInstance.post("/roles", values);
                message.success("Role berhasil dibuat");
            }
            setModalVisible(false);
            fetchRoles();
        } catch (err) {
            console.error(err);
            message.error("Gagal menyimpan role");
        }
    };

    const columns = [
        {
            title: "Role Name",
            dataIndex: "user_level",
            key: "user_level"
        },

        {
            title: "Action",
            key: "action",
            render: (_, record) => (
                <>
                    <Button
                        icon={<SettingOutlined />}
                        onClick={() => handlePermissions(record)}
                        style={{ marginRight: 8 }}
                        disabled={record.id_user_level === 1}
                    >
                        Akses
                    </Button>
                    <Button
                        icon={<EditOutlined />}
                        onClick={() => handleEdit(record)}
                        style={{ marginRight: 8 }}
                        disabled={record.id_user_level === 1}
                    />
                    <Button
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => handleDelete(record)}
                        disabled={record.id_user_level === 1}
                    />
                </>
            )
        }
    ];

    return (
        <Card title="Management Akses Role" extra={<Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>Tambah Role</Button>}>
            <Table
                dataSource={roles}
                columns={columns}
                rowKey="id_user_level"
                loading={loading}
                pagination={false}
            />

            <Modal
                title={selectedRole ? "Edit Role" : "Tambah Role"}
                visible={modalVisible}
                onOk={handleSave}
                onCancel={() => setModalVisible(false)}
            >
                <Form form={form} layout="vertical">
                    <Form.Item name="user_level" label="Nama Role" rules={[{ required: true }]}>
                        <Input />
                    </Form.Item>

                </Form>
            </Modal>

            {matrixVisible && (
                <PermissionMatrix
                    visible={matrixVisible}
                    onClose={() => setMatrixVisible(false)}
                    role={selectedRole}
                />
            )}
        </Card>
    );
};

export default RoleAccess;
